/** Space photos use a new Storage path per upload — safe to cache for 1 year. */
export const SPACE_IMAGE_CACHE_CONTROL = 'public, max-age=31536000, immutable';

/** Booking receipts: unique path per upload; shorter private cache. */
export const BOOKING_RECEIPT_CACHE_CONTROL = 'private, max-age=3600';

/** Profile avatars: overwritten in place — short public cache. */
export const PROFILE_AVATAR_CACHE_CONTROL = 'public, max-age=3600';
